export default __webpack_public_path__ + "static/media/LOCKD.36198ed2.jpg";